// composables/useDistance.ts

/**
 * Returns a function to compute distance between two geo-points.
 */
export function useDistance() {
    const toRad = (deg: number) => (deg * Math.PI) / 180
  
    /**
     * Calculates the great-circle distance between two points
     * given in decimal degrees using the Haversine formula.
     *
     * @param lat1 latitude of point A
     * @param lon1 longitude of point A
     * @param lat2 latitude of point B
     * @param lon2 longitude of point B
     * @param radius Earth radius in kilometers (default 6371)
     * @returns distance in kilometers
     */
    function getDistance(
      lat1: number,
      lon1: number,
      radius = 6371
    ): number {


           
      const locationCookie = useCookie<{ lat: number; lng: number }>('location', {
        default: () => ({ lat: 0, lng: 0 })
      });

      if (!locationCookie.value.lat) {
        return 0;
      }
      const φ1 = toRad(lat1)
      const φ2 = toRad(locationCookie.value.lat)
      const Δφ = toRad(locationCookie.value.lat - lat1)
      const Δλ = toRad(locationCookie.value.lng - lon1)
  

   

      const a =
        Math.sin(Δφ / 2) * Math.sin(Δφ / 2) +
        Math.cos(φ1) * Math.cos(φ2) *
        Math.sin(Δλ / 2) * Math.sin(Δλ / 2)
  
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
      return radius * c
    }
  
    return { getDistance }
  }
  